import React from "react";
import "./DepositoLotePanel.css";

const UNITARIO_COLUMNS = [
  { key: "data", label: "Data", colClass: "dep-lote-panel__col--date" },
  { key: "perfil", label: "Perfil", colClass: "dep-lote-panel__col--perfil" },
  { key: "classe", label: "Classe", colClass: "dep-lote-panel__col--classe" },
  { key: "metragem", label: "Metragem", colClass: "dep-lote-panel__col--metragem" },
  { key: "furos", label: "Furos", colClass: "dep-lote-panel__col--furos" },
  { key: "vagao", label: "Vagao", colClass: "dep-lote-panel__col--vagao" },
  { key: "fabricante", label: "Fabricante", colClass: "dep-lote-panel__col--fabricante" },
  { key: "defeito", label: "Defeito", colClass: "dep-lote-panel__col--defeito" },
  { key: "motivo", label: "Motivo do Defeito", colClass: "dep-lote-panel__col--motivo" },
];

function UnitarioColGroup() {
  return (
    <colgroup>
      {UNITARIO_COLUMNS.map((column) => (
        <col key={column.key} className={column.colClass} />
      ))}
    </colgroup>
  );
}

export default function DepositoLotePanel({ lote, detail, formatDate, formatInt, formatNumber, inline = false }) {
  if (!lote) return null;

  const rootClassName = `dep-lote-panel ${inline ? "dep-lote-panel--inline" : ""}`.trim();
  const headClassName = `dep-lote-panel__head ${inline ? "dep-lote-panel__head--inline" : ""}`.trim();

  return (
    <section className={rootClassName}>
      <div className={headClassName}>
        {!inline ? (
          <div className="dep-lote-panel__title">
            <h3>{`Barras do lote ${lote.codigo_lote || "-"}`}</h3>
            <p>Detalhamento individual das barras registradas nesse lote.</p>
          </div>
        ) : null}

        <div className="dep-lote-panel__meta">
          <span>Barras: {formatInt(lote.total_barras)}</span>
          <span>Pecas: {formatNumber(lote.total_pecas, 0)}</span>
          <span>Metragem: {formatNumber(lote.total_metragem)}</span>
        </div>
      </div>

      <div className="dep-lote-panel__body">
        {detail?.loading ? (
          <p className="dep-lote-panel__state">Carregando barras...</p>
        ) : detail?.error ? (
          <p className="dep-lote-panel__state dep-lote-panel__state--error">Erro: {detail.error}</p>
        ) : (
          <div className="dep-lote-panel__scroll-shell">
            <div className="dep-lote-panel__table-head">
              <table className="dep-table dep-lote-panel__table dep-lote-panel__table--head">
                <UnitarioColGroup />
                <thead>
                  <tr>
                    {UNITARIO_COLUMNS.map((column) => (
                      <th key={column.key}>{column.label}</th>
                    ))}
                  </tr>
                </thead>
              </table>
            </div>

            <div className="dep-lote-panel__scroll">
              <table className="dep-table dep-lote-panel__table dep-lote-panel__table--body">
                <UnitarioColGroup />
                <tbody>
                  {(detail?.barras || []).map((barra) => (
                    <tr key={barra.id || barra.codigo_barra}>
                      <td>{formatDate(barra.created_at)}</td>
                      <td>{barra.perfil_trilho || ""}</td>
                      <td>{barra.classe_trilho || ""}</td>
                      <td>{formatNumber(barra.metragem_pecas)}</td>
                      <td>{barra.furos || ""}</td>
                      <td>{barra.codigo_vagao || ""}</td>
                      <td>{barra.marca_barra || ""}</td>
                      <td>{barra.defeito || ""}</td>
                      <td>{barra.motivo_defeito || ""}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
